import { DatePicker } from '@mui/lab';
import { Divider, Grid, Typography, useEventCallback } from '@mui/material';
import { useFormikContext } from 'formik';
import { DocumentFormVM } from 'front-office/view-models/document/document-form';
import { Fragment, memo } from 'react';
import { PmiTitleDivider } from 'shell/components/shared/pmi-title-divider';
import PmiTextField from 'shell/components/shared/text-field';
import TypeResidenceList from 'shell/components/shared/type-residence';
import MunicipalityList from 'shell/components/shared/municipality-list';
import { PmiInputFile } from 'shell/components/shared/file-input';
import AccordionPerson from './person';
import ResidencyPermit from './old-residency-permit';
import PmiDivider from 'shell/components/shared/divider';

const FormDocumentComponent = (): React.ReactElement => {
  const formContext = useFormikContext<DocumentFormVM>();

  const handleAddFile = useEventCallback((file: File) => {
    formContext.setFieldValue('file', file);
  });

  return (
    <Fragment>
      <Typography gutterBottom variant="h5" component="h2" color="secondary">
        Registrazione permesso di soggiorno
      </Typography>
      <div style={{ padding: '24px 0 0 0' }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12}>
            <AccordionPerson disabled />
          </Grid>
          <Grid item xs={12}>
            <ResidencyPermit disabled />
          </Grid>
          <Grid item xs={12}>
            <PmiDivider />
          </Grid>
          <Grid item xs={12} md={4}>
            <PmiTextField
              aria-label="Numero permesso"
              label="Numero permesso *"
              id="numberAllowed"
              name="numberAllowed"
              fullWidth
              type="text"
              variant="outlined"
              value={formContext.values.numberAllowed || ''}
              onChange={formContext.handleChange}
              inputProps={{
                maxLength: '20',
              }}
              error={formContext.touched.numberAllowed && Boolean(formContext.errors.numberAllowed)}
              helperText={formContext.errors.numberAllowed}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <TypeResidenceList
              label="Tipo *"
              aria-label="Tipo"
              onChange={(residence) => {
                formContext.setFieldValue('type', residence);
              }}
              value={formContext.values.type || ''}
              error={formContext.touched.type && Boolean(formContext.errors.type)}
            />
          </Grid>
          {formContext.values.type === '9' ? (
            <Grid item xs={12}>
              <PmiTextField
                label="Note"
                aria-label="Note"
                id="note"
                name="note"
                fullWidth
                multiline
                rows={5}
                inputProps={{
                  maxLength: '240',
                }}
                value={formContext.values?.note || ''}
                onChange={formContext.handleChange}
                error={formContext.touched.note && Boolean(formContext.errors.note)}
                helperText={formContext.errors.note}
              />
            </Grid>
          ) : undefined}
          <Grid item xs={12} md={4}>
            <DatePicker
              label="Data rilascio *"
              aria-label="Data rilascio"
              value={formContext.values.dateRelease || null}
              onChange={(date) => {
                formContext.setFieldValue('dateRelease', date);
              }}
              renderInput={(params) => (
                <PmiTextField
                  {...params}
                  fullWidth
                  error={formContext.touched.dateRelease && Boolean(formContext.errors.dateRelease)}
                  helperText={formContext.errors.dateRelease}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DatePicker
              label="Data Dichiarazione *"
              aria-label="Data Dichiarazione"
              value={formContext.values.dateDeclaration || null}
              onChange={(date) => {
                formContext.setFieldValue('dateDeclaration', date);
              }}
              renderInput={(params) => (
                <PmiTextField
                  {...params}
                  fullWidth
                  error={
                    formContext.touched.dateDeclaration &&
                    Boolean(formContext.errors.dateDeclaration)
                  }
                  helperText={formContext.errors.dateDeclaration}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <DatePicker
              label="Data scadenza"
              aria-label="Data scadenza"
              value={formContext.values.dateExpiration || null}
              onChange={(date) => {
                formContext.setFieldValue('dateExpiration', date);
              }}
              renderInput={(params) => (
                <PmiTextField
                  {...params}
                  fullWidth
                  error={
                    formContext.touched.dateExpiration && Boolean(formContext.errors.dateExpiration)
                  }
                  helperText={formContext.errors.dateExpiration}
                />
              )}
            />
          </Grid>
          {/* <Grid item xs={12}>
            <PmiTextField
              aria-label="Questura rilascio"
              label="Questura rilascio"
              id="questuraRelease"
              name="questuraRelease"
              fullWidth
              type="text"
              variant="outlined"
              value={formContext.values.questuraRelease}
              onChange={formContext.handleChange}
              inputProps={{
                maxLength: '50',
              }}
            />
          </Grid> */}
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12}>
            <PmiTitleDivider>Questura rilascio</PmiTitleDivider>
          </Grid>
          <Grid item xs={12} md={6}>
            <MunicipalityList
              label="Comune *"
              fromDate={formContext.values.dateRelease}
              aria-label="Comune"
              value={formContext.values.municipality || null}
              onChange={(element) => {
                formContext.setFieldValue('municipality', element);
              }}
              error={formContext.touched.municipality && Boolean(formContext.errors.municipality)}
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <PmiTextField
              label="Provincia"
              id="province"
              name="province"
              inputProps={{
                maxLength: '2',
              }}
              aria-label="Provincia"
              fullWidth
              value={
                formContext.values.province || formContext.values?.municipality?.province || ''
              }
              onChange={formContext.handleChange}
            />
          </Grid>
          {/* <Grid item xs={12} md={10}>
            <PmiTextField
              aria-label="Località"
              label="Località"
              id="locality"
              name="locality"
              fullWidth
              type="text"
              inputProps={{
                maxLength: '120',
              }}
              variant="outlined"
              value={formContext.values.locality}
              onChange={formContext.handleChange}
            />
          </Grid> */}
          <Grid item xs={12}>
            <Divider />
          </Grid>
          {/* <Grid item xs={12} md={6}>
            <PmiTextField
              aria-label="Numero passaporto"
              label="Numero passaporto"
              id="passportNumber"
              name="passportNumber"
              fullWidth
              type="text"
              variant="outlined"
              value={formContext.values.passportNumber}
              onChange={formContext.handleChange}
              inputProps={{
                maxLength: '30',
              }}
            />
          </Grid> */}
          <Grid item xs={12}>
            Carica documento cartaceo&nbsp;
            <PmiInputFile
              multiple={false}
              file={formContext.values.file}
              onChange={handleAddFile}
              color="cdmBrandThird"
            />
          </Grid>
        </Grid>
      </div>
    </Fragment>
  );
};

FormDocumentComponent.displayName = 'Form Document component';

const FormDocument = memo(FormDocumentComponent);

export default FormDocument;
